import { useEffect, useState } from "react";
import "../../../src/styles/Components/Write/WriteBoard.css";
import {
  ContractTemplateApi,
  ContractTemplateAttachmentApi,
  ErrorHandler,
} from "../../system/ApiService";
import { Link, useHistory } from "react-router-dom";
import { useUserState } from "../../system/context/UserContext";

// syncfusion
import { enableRipple } from "@syncfusion/ej2-base";
import { ButtonComponent } from "@syncfusion/ej2-react-buttons";

import HtmlContent from "../Common/HtmlContext";
import AlertModal from "../Common/AlertModal";
import { Grid } from "@mui/material";
import { CustomText } from "../../styles/Components/Portlet/CustomText";
import {
  CustomButtonGreen,
  CustomButtonGrey,
  CustomButtonRed,
} from "../../styles/Common/CommonComponent";

function ContractTemplateDetailBoard(props: any) {
  let history = useHistory();
  const id = props.data.contractTemplateId;
  const user = useUserState();

  // 버튼
  enableRipple(true);

  //// 글 삭제
  const ContractTemplateDelete = () => {
    if (window.confirm("계약서 양식을 삭제하시겠습니까?")) {
      ContractTemplateApi.DeleteContractTemplate(props.data.contractTemplateId)
        .then(() => {
          AlertModal("success", "계약서 양식이 삭제되었습니다.");
          history.push("/contractTemplate/board/1");
        })
        .catch((error) => {
          let msg = ErrorHandler(error);
          AlertModal("msg", msg);
        });
    }
  };
  const [uploadData, setUploadData] = useState([]);
  // 첨부 파일 정보
  useEffect(() => {
    if (props.data.fileuploadFolder) {
      ContractTemplateAttachmentApi.GetContractTemplateAttachmentList(
        props.data.fileuploadFolder
      )
        .then((res) => {
          setUploadData(res.data);
        })
        .catch((error) => {
          let msg = ErrorHandler(error);
          AlertModal("msg", msg);
        });
    }
  }, [props]);

  function downloadfile(item: any) {
    window.location.assign(
      `https://inbodyinfra.blob.core.windows.net/inbodyportal/ContractTemplate/${item.fileuploadFolder}/${item.contractTemplateAttachmentFileName}`
    );
  }

  return (
    <>
      {props.data ? (
        <div
          className={
            user.teamName === props.data.teamName ? "boardTeam" : "board"
          }
        >
          <div className="board_write">
            <div className="title">
              <Grid container alignItems="center" mb="10px">
                <Grid item mr="45px">
                  <CustomText type="title">제목</CustomText>
                </Grid>

                <Grid>
                  <CustomText type="subtitle2">
                    {props.data.contractTemplateTitle}
                  </CustomText>
                </Grid>
              </Grid>
            </div>
            <div className="contractTemplate_info">
              <Grid container alignItems="center" mb="10px">
                <Grid container item xs={12} sm={6} alignItems="center">
                  <Grid item mr="25px">
                    <CustomText type="title">작성자</CustomText>
                  </Grid>
                  <Grid item>
                    <CustomText type="subtitle2">
                      {props.data.contractTemplateWriter}
                    </CustomText>
                  </Grid>
                </Grid>

                {props.data.contractTemplateCreatedAt ===
                props.data.contractTemplateModifiedAt ? (
                  <Grid container item xs={12} sm={6} alignItems="center">
                    <Grid item mr="25px">
                      <CustomText type="title">작성일</CustomText>
                    </Grid>
                    <Grid item>
                      <CustomText type="subtitle2">
                        {props.data.contractTemplateCreatedAt}
                      </CustomText>
                    </Grid>
                  </Grid>
                ) : (
                  <Grid container item xs={12} sm={6} alignItems="center">
                    <Grid item mr="25px">
                      <CustomText type="title">수정일</CustomText>
                    </Grid>
                    <Grid>
                      <CustomText type="subtitle2">
                        {props.data.contractTemplateModifiedAt}
                      </CustomText>
                    </Grid>
                  </Grid>
                )}
              </Grid>
            </div>
            <div className="cont">
              <Grid container alignItems="center" mb="15px">
                <Grid item xs={12}>
                  <CustomText type="title">내용</CustomText>
                </Grid>
                <Grid item xs={12} mt="15px">
                  <HtmlContent
                    data={
                      props.data.contractTemplateContent
                        ? props.data.contractTemplateContent
                        : "작성된 내용이 없습니다."
                    }
                  ></HtmlContent>
                </Grid>
              </Grid>
            </div>
            <div className="info">
              <div className="fileuploadbox">첨부파일</div>
              <div className="filebox">
                {uploadData.map((item: any) => (
                  <li key={`${item.contractTemplateAttachmentFileName}`}>
                    {item.contractTemplateAttachmentFileName}
                    <ButtonComponent
                      iconCss="e-icons e-download"
                      className="fileuploadButton"
                      onClick={() => downloadfile(item)}
                    >
                      다운로드
                    </ButtonComponent>
                  </li>
                ))}
              </div>
            </div>
          </div>
          <div className="bt_wrap">
            {(user.employeeId === "20220914" ||
              user.employeeId === "20210601" ||
              user.employeeId === "20240901") && (
              <>
                <span>
                  <CustomButtonGreen
                    style={{ margin: "5px" }}
                    onClick={() => {
                      history.push({
                        pathname: `/contractTemplate/edit/${id}`,
                        state: id,
                      });
                    }}
                  >
                    수정
                  </CustomButtonGreen>
                </span>
                <span>
                  <CustomButtonRed
                    onClick={ContractTemplateDelete}
                    style={{ margin: "10px" }}
                  >
                    삭제
                  </CustomButtonRed>
                </span>
              </>
            )}

            <span>
              <Link to="/contractTemplate/board/1" style={{ margin: "5px" }}>
                <CustomButtonGrey>목록</CustomButtonGrey>
              </Link>
            </span>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
}

export default ContractTemplateDetailBoard;
